export default "__VITE_ASSET__2lPbn7Jq__"